// @flow
/** @jsx isolateComponent */

import { AsyncIndicator } from '@zapier/common-components';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

const Styles = labelStyles(__filename, {
  root: {
    padding: '0 10px',
  },
});

const Loader = () => {
  return (
    <div css={Styles.root}>
      <AsyncIndicator />
    </div>
  );
};

export default Loader;
